import React, { Fragment } from 'react';

const WhatisAutzuEVSF = () => (
  <Fragment>
    <p>
      Autzu EV is our tier of zero-emission electric vehicles, starting at
      $7 per hour. Autzu EV vehicles allow you to accept various
      ridesharing trip requests, including:
    </p>
    <ul>
      <li>Standard (UberX, UberX Share, Uber Pet)</li>
      <li>Premium (Comfort, Premier)</li>
      <li>Green (Uber Green, Comfort Electric)</li>
      <li>Other (Pet, Connect)</li>
      <li>Food Delivery (Uber Eats)</li>
    </ul>
    <br />
    <p>
      When driving Autzu EV, you will be able to opt-in to Uber’s Zero
      Emission Incentive program.
    </p>
    <p>
      Starting on April 11, 2024, drivers of fully electric vehicles can
      earn an extra $210 after completing 200 eligible rides in an EV every
      30 days through the end of 2024. Learn more about how you can reduce
      your carbon footprint by going green{' '}
      <a
        href="https://www.uber.com/us/en/drive/services/electric/?uclick_id=346a868e-74fc-4620-b616-7e6f19f7a244"
        target="_blank">
        here.
      </a>{' '}
      Autzu EV drivers will also automatically get $0.50 extra directly
      from riders for each Uber Green trip.
    </p>
  </Fragment>
);

export default WhatisAutzuEVSF;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/General/WhatIsAutzuEVSF.js